<template>
  <privat-otp-auth-blank-form
    submit-label="Отправить"
    :user="user"
    :errors="errors"
    @submit="processOtpAuthForm"
  />
</template>

<script>
import helpers from '@/helpers'
import { privatOtpAuth } from '@/services/privat_auth.service'
import privatOtpAuthBlankForm from '@/components/forms/privat_otp_auth/PrivatOtpAuthBlankForm'

export default {
  name: 'privat-otp-auth-form',
  components: { privatOtpAuthBlankForm },
  data () {
    return {
      user: {
        otp: ''
      },

      errors: {
        user: {
          otp: []
        },
        non_field_errors: []
      }
    }
  },
  methods: {
    fillErrors: helpers.fillErrors,
    fillNonFieldErrors: helpers.fillNonFieldErrors,

    processOtpAuthForm () {
      this.privatOtpAuth().then((success) => {
        if (success) {
          this.showMsg('Авторизация прошла успешно!', 'success', 'Успешно')
          this.$emit('after', true)
        } else {
          this.$emit('after', false)
        }
      })
    },
    privatOtpAuth () {
      return privatOtpAuth(this.user).then((response) => {
        this.fillErrors(this.errors.user, {})
        return true
      }).catch(err => {
        this.fillErrors(this.errors.user, err.response.data)

        if (err.response.status === 400) {
          this.fillNonFieldErrors(this.errors, err.response.data)
          if (this.errors.non_field_errors[0]) {
            this.showMsg(this.errors.non_field_errors[0], 'error', 'Ошибка')
          }
        } else if (err.response.status === 404) {
          this.$router.push({ name: 'privat-auth' })
          this.showMsg('Срок сессии истек! Авторизуйтесь снова.', 'error', 'Ошибка')
        }

        return false
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// PrivatOtpAuthForm.vue?79b47259